/*global chrome*/
import React from 'react';
import { Link } from 'react-router-dom';
import API, { base } from "../../api.js";
import Slider from "react-slick";

class VideoTuts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      homePage: false,
      list: [],
    };
  }
 

  render() {  
    const Turorialvideos = {
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            dots: true,
            arrows: true,
          },
        },
      ],
    };

    return (
      <div className="video-section left-arrow-slider slider-dot-arrow">
          <h2
            className="primary-heading text-center"
            dangerouslySetInnerHTML={{ __html: this.props.title }}
          />          
            <Slider {...Turorialvideos}>
              {[
                "ib-ixzMIxB0",
                "vZMVTmsCmjc",
                "pJLaXWI1AqI",
                "r2er4KkdWUk",
                "bOay9ScIfGM",
              ].map((videoId, index) => (
                <div key={index}>
                  <div className="iframe-video-wrapper">
                    <iframe
                      className="iframe-video"
                      src={`https://www.youtube.com/embed/${videoId}`}
                      allowFullScreen
                      title={`Student Testimonial Video ${index + 1}`}
                    />
                  </div>
                </div>
              ))}
            </Slider>
          <div className="text-center">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.youtube.com/@LanguageAcademyPTE"
              className="primary-btn"
            >
              VIEW ALL VIDEOS <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
            </a>
        </div>
      </div>


     
    );
  }
}

export default VideoTuts;
